import {locationContainer} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';
import {EventAnnotation} from 'src/js/containers/encounter/components/EventAnnotation';
import baseTimelineAnnotationsStatefullFormatterParams from 'src/js/lib/raw_rendering/base_timeline_annotations_statefull_formatter_params';
import {EncounterTimelineEventAnnotation} from 'src/js/model/encounter_timeline';

export class TimelineAnnotationsStatefullFormatter extends React.PureComponent {
  render() {
    const {ownQueryParameters, value} =
      baseTimelineAnnotationsStatefullFormatterParams(this.props);

    return value ? (
      <div>
        {value &&
          value.annotations &&
          value.annotations.map((annotation, idx) => (
            <EventAnnotation
              /* eslint-disable-next-line react/no-array-index-key */
              key={idx}
              annotation={annotation}
              caseId={value.caseId}
              queryParameters={
                ownQueryParameters[locationContainer.GLOBAL_PARAMETERS_PATH]
              }
            />
          ))}
      </div>
    ) : (
      ''
    );
  }
}

TimelineAnnotationsStatefullFormatter.displayName =
  'TimelineAnnotationsStatefullFormatter';

TimelineAnnotationsStatefullFormatter.propTypes = {
  value: PropTypes.shape({
    caseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    annotations: PropTypes.arrayOf(
      PropTypes.instanceOf(EncounterTimelineEventAnnotation)
    ),
  }),
};

TimelineAnnotationsStatefullFormatter.defaultProps = {
  value: undefined,
};

export default connect((state) => ({
  queryParameters:
    state[locationContainer.LOCATION_REDUCER_STATE_ID].parameters,
}))(TimelineAnnotationsStatefullFormatter);
